import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import clientsReducer from './slices/clientsSlice';
import demarchesReducer from './slices/demarchesSlice';
import reparationsReducer from './slices/reparationsSlice';
import facturesReducer from './slices/facturesSlice';
import clientAuthReducer from './slices/clientAuthSlice';
import notesReducer from './slices/notesSlice';
import cyberUsersReducer from './slices/cyberUsersSlice';
import cyberDashboardReducer from './slices/cyberDashboardSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    clients: clientsReducer,
    demarches: demarchesReducer,
    reparations: reparationsReducer,
    factures: facturesReducer,
    clientAuth: clientAuthReducer, // NOUVEAU : authentification clients publics
    notes: notesReducer, // NOUVEAU : notes de démarches
    cyberUsers: cyberUsersReducer, // NOUVEAU : gestion des utilisateurs cyber
    cyberDashboard: cyberDashboardReducer, // NOUVEAU : tableau de bord cyber
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
